import {Breadcrumbs, Btn, H5} from "../../AbstractElements";
import {Card, CardBody, CardHeader, Col, Container, Row} from "reactstrap";
import Drawer from "react-modern-drawer";
import React, {useState} from "react";
import {CourseForms} from "./CourseForms";
import {CourseDataTable} from "../../Components/DataTables/CourseDataTable";

const ManageCoursePage = () => {
    const [drawerState, setDrawerState] = useState({
        forms: false,
        editId: 0
    })

    const closeAllDrawer = () => {
        setDrawerState({
            forms: false,
            editId: 0
        })
    }

    return (
        <>
            <Breadcrumbs parent="Course" title="Manage Course" mainTitle="Manage Course"/>
            <Container fluid={true} className="datatables">
                <Row>
                    <Col sm="12">
                        <Card>
                            <CardHeader className="pb-0">
                                <Row className="justify-content-between">
                                    <Col md={"auto"}>
                                        <H5>Manage Course</H5>
                                    </Col>
                                    <Col md={"auto"}>
                                        <Btn attrBtn={{
                                            color: "secondary",
                                            className: "m-r-15",
                                            onClick: (e) => setDrawerState({...drawerState, forms: true, editId: 0})
                                        }}>New Course</Btn>
                                    </Col>
                                </Row>
                            </CardHeader>
                            <CardBody>
                                <CourseDataTable drawerState={drawerState} setDrawerState={setDrawerState}/>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
            <Drawer
                open={drawerState.forms}
                onClose={closeAllDrawer}
                direction="right"
                className={'creation-drawer'}
            >
                <CourseForms id={drawerState.editId}/>
            </Drawer>
        </>
    )

}

export default ManageCoursePage